







































































































import { readUserProfile } from '@/store/main/getters';
import { dispatchGetStaffDashboardStatisticsByCountries } from '@/store/staff/actions';
import { readStaffDashboardStatistics, readStaffDashboardStatisticsByCountries } from '@/store/staff/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class StatsByCountriesTable extends Vue {
  // @ts-ignore
  @Prop({required: false, default: ''}) readonly public className: string;
  public currentPeriod: any = 'today';
  public currentPage = 1;
  public perPage = 6;
  public loadingState = {
    list: false,
  };

  public async mounted() {
    this.loadingState.list = true;
    this.currentPeriod = this.$t('Today');
    await dispatchGetStaffDashboardStatisticsByCountries(this.$store, {});
    this.loadingState.list = false;
  }

  get dashboardStats() {
    return readStaffDashboardStatistics(this.$store);
  }

  public async handleChangePeriod(period) {
    this.currentPeriod = period[1];
    this.loadingState.list = true;
    await dispatchGetStaffDashboardStatisticsByCountries(this.$store, {period: period[0]});
    this.loadingState.list = false;
  }

  get countriesList() {
    return readStaffDashboardStatisticsByCountries(this.$store);
  }

  public convertTimeSpent(total) {
      const seconds = total > 0 ? Math.floor( (total) % 60 ) : '00';
      const minutes = total > 0 ? Math.floor( (total / 60) % 60 ) : '00';
      const hours = total > 0 ? Math.floor( (total / (60 * 60)) % 24 ) : '00';
      const days = total > 0 ? Math.floor( total / (60 * 60 * 24) ) : '00';
      return `${days}:${hours}:${minutes}:${seconds}`;
  }

  get countriesFields() {
    return [
      {
        key: 'country',
        label: this.$t('Country'),
        sortable: true,
      },
      {
        key: 'tasks',
        label: this.$t('Tasks'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      },
      {
        key: 'new_users',
        label: this.$t('New users'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      },
      {
        key: 'time_spent',
        label: this.$t('Time spent'),
        sortable: true,
        thClass: 'text-right',
        tdClass: 'text-right',
      },
    ];
  }

  get available() {
    const groups = [
      'Руководитель отдела консультантов', 'Админы',
      "Администратор отдела консультирования",
      "Администратор партнерского отдела",
      "Руководитель отдела консультирования",
      "Руководитель партнерского отдела",
    ];
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      for (const [key, value] of Object.entries(groups)) {
        if (userProfile.groups.includes(value)) {
          return true;
        }
      }
    }
    return false;
  }

}
